/**
 * @generated SignedSource<<39b72091d56fde6798f9421171531442>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Urgency = "MEDICAL_ACUTE" | "MEDICAL_URGENT" | "NORMAL";
import { FragmentRefs } from "relay-runtime";
export type urgentAcuteAppointmentWarning_waitingRoomDay$data = ReadonlyArray<{
  readonly slots: ReadonlyArray<{
    readonly appointments: ReadonlyArray<{
      readonly appointment: {
        readonly urgency: Urgency;
      };
    }>;
  }>;
  readonly " $fragmentType": "urgentAcuteAppointmentWarning_waitingRoomDay";
}>;
export type urgentAcuteAppointmentWarning_waitingRoomDay$key = ReadonlyArray<{
  readonly " $data"?: urgentAcuteAppointmentWarning_waitingRoomDay$data;
  readonly " $fragmentSpreads": FragmentRefs<"urgentAcuteAppointmentWarning_waitingRoomDay">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "urgentAcuteAppointmentWarning_waitingRoomDay",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WaitingRoomSlot",
      "kind": "LinkedField",
      "name": "slots",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WaitingRoomAppointment",
          "kind": "LinkedField",
          "name": "appointments",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Appointment",
              "kind": "LinkedField",
              "name": "appointment",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urgency",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomDay",
  "abstractKey": null
};

(node as any).hash = "6e0162243654dc216da0c9ee906ad389";

export default node;
